"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressDownload = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const atoms_1 = require("../../atoms");
const solid_1 = require("@heroicons/react/20/solid");
const react_2 = require("@headlessui/react");
function ProgressDownload({ isPolling, isFailure, isSuccess, text = 'Gathering data. This process should only take a couple of minutes. Please wait...', onCancel, onClose, testId, className, }) {
    const [hasPolled, setHasPolled] = (0, react_1.useState)(false);
    const [show, setShow] = (0, react_1.useState)(false);
    const handleClose = () => {
        setShow(false);
        setHasPolled(false);
        if (onClose) {
            onClose();
        }
    };
    (0, react_1.useEffect)(() => {
        if (isSuccess || isFailure)
            setHasPolled(true);
        if ((isPolling || isSuccess || isFailure) && !show)
            setShow(true);
    }, [isPolling]);
    const getMessage = () => {
        if (isSuccess)
            return 'Success!';
        if (isFailure)
            return 'Error: data mapping is still processing. Please try again later and contact us if the error persists';
        if (isPolling)
            return text;
        return '';
    };
    return (react_1.default.createElement("div", { "data-testid": testId },
        react_1.default.createElement(react_2.Transition, { as: react_1.Fragment, show: show, appear: show, enter: "transform transition duration-[600ms]", enterFrom: "translate-y-[200px]", enterTo: "translate-y-0", leave: "transform transition duration-[600ms]", leaveFrom: "translate-y-2", leaveTo: "translate-y-[200px]" },
            react_1.default.createElement("div", { className: (0, clsx_1.default)('w-full', 'max-w-[468px]', 'bg-gray-700', 'rounded-[8px]', 'border', 'border-borderColor', 'p-6', 'fixed', 'z-50', 'bottom-[32px]', 'right-[32px]', 'shadow-default', className) },
                react_1.default.createElement("div", { className: "flex items-center justify-between" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.HEADING_M }, "Download")),
                    react_1.default.createElement("div", { className: "flex items-center" },
                        isPolling && onCancel && (react_1.default.createElement(atoms_1.Button, { type: atoms_1.ButtonType.SECONDARY, onClick: () => {
                                onCancel();
                                setShow(false);
                                setHasPolled(false);
                            } }, "Cancel")),
                        (hasPolled || isFailure || isSuccess) && (react_1.default.createElement("button", { onClick: handleClose, className: "ml-2", "data-testid": "close-progress-download" },
                            react_1.default.createElement(atoms_1.Icon.Close, null))))),
                react_1.default.createElement("div", { className: "flex items-center justify-between mt-4" },
                    react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.UI_ELEMENT, subdued: true, className: "mr-2 overflow-hidden overflow-ellipsis" }, getMessage()),
                    react_1.default.createElement("div", { className: "flex" },
                        isFailure && !isPolling && (react_1.default.createElement(solid_1.ExclamationTriangleIcon, { "data-testid": "polling-error-icon", fill: "#FF8A8A", width: 16 })),
                        isSuccess && !isPolling && !isFailure && (react_1.default.createElement(solid_1.CheckIcon, { "data-testid": "polling-success-icon", fill: "#72C681", width: 16 })),
                        isPolling && !isSuccess && !isFailure && react_1.default.createElement(atoms_1.Spinner, null)))))));
}
exports.ProgressDownload = ProgressDownload;
//# sourceMappingURL=ProgressDownload.js.map